import React, { useState } from "react"
import * as Yup from "yup"
import { useFormik } from "formik"

import { Button } from "../button"
import { LabelledInput } from "../inputs"
import { useAuth } from "../../providers/auth/AuthProvider"
import { SuccessNotice } from "../notice"
import updateUserRecord from "../../bssr-api/auth0/update-user"
import Fieldset from "../fieldset"

export default function AccountDetailsForm({ token }) {
  const [state, dispatch] = useAuth()
  const [isSuccess, setSuccess] = useState()
  const [loading, setLoading] = useState(false)

  const accountDetailsSchema = Yup.object().shape({
    given_name: Yup.string().required("This is a required field"),
    family_name: Yup.string().required("This is a required field"),
    email: Yup.string()
      .email("Oops. The email address doesn't look quite right.")
      .required("This is a required field"),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    initialValues: {
      given_name: state.given_name,
      family_name: state.family_name,
      email: state.email,
    },
    onSubmit: async (values) => {
      // If the green bar is already present then remove it
      if (isSuccess) {
        setSuccess(false)
      }

      setLoading(true)

      const { given_name, family_name, email } = values
      const res = await updateUserRecord(
        state.user_id,
        {
          given_name,
          family_name,
        },
        false,
        token
      )

      dispatch({ type: "setUser", payload: res.data })
      setSuccess(true)
      setLoading(false)
    },
    validationSchema: accountDetailsSchema,
  })

  const errors = formik.errors

  return (
    <form className="mt-3 mb-6" onSubmit={formik.handleSubmit}>
      <h3 className="font-bold text-lg lg:text-xl text-gray-800 py-3 mt-4">
        Personal Details
      </h3>

      {isSuccess && (
        <SuccessNotice>
          Your Personal Details were updated successfully.
        </SuccessNotice>
      )}

      <Fieldset name="account-details">
        <div className="flex flex-wrap">
          <div className="w-full md:w-1/2 md:pr-2">
            <LabelledInput
              label="Given name*"
              id="given_name"
              name="given_name"
              onChange={formik.handleChange}
              value={formik.values.given_name}
              error={errors.given_name}
            />
          </div>

          <div className="w-full md:w-1/2 md:pl-2">
            <LabelledInput
              label="Family name*"
              id="family_name"
              name="family_name"
              onChange={formik.handleChange}
              value={formik.values.family_name}
              error={errors.family_name}
            />
          </div>
        </div>
      </Fieldset>

      <Button
        type="submit"
        isLoading={loading}
        className="w-full md:w-1/4 mt-4"
      >
        Update Personal Details
      </Button>
    </form>
  )
}
